export const ABMFE_CONTENTS = {
    'SHIP_TO': '0000601526',
    'TIMEZONE': '420',
    'LANGCODE': 'en',
    // 'DEP_RESELLER_ID': '6FFA140',
    'DEP_RESELLER_ID': '722D390',
    'PARTNER_TXN_ID': 'TXN_001127',
    'ENROLEE_EMAIL': 'chin_yit_phang@apple.com',
    'ORG_TYPE': 'BUSINESS',
    'ORG_WEBSITE': 'https://test.com',
    'ENROLEE_JOB_TITLE': 'Telecom Manager',
    'ORG_EDU_MARKET': '',
    'ENROLEE_LOCALE': 'en-us',
    'SECONDARY_CONTACT_LOCALE': 'en-us'
};
